import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";
import { Wrapper } from "../helper/warpLabels";

//#### Bar Chart

// Create a bar chart and use the given css selector as anchor. You can also specify
// an optional chart group for this chart to be scoped within. When a chart belongs
// to a specific group then any interaction with such chart will only trigger redraw
// on other charts within the same chart group.

const sizeChartFunc = (divRef, ndx) => {
  function remove_empty_bins(source_group) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
          return d.value !== 0; // if integers only
        });
      },
    };
  }
    const dimension = ndx.dimension((d) => d.use_Of_Financing_Resources);
    const dealCountGrp = dimension.group().reduceCount();

    // define the chart object
    const sizeChart = dc.barChart(divRef);

  sizeChart
    .width(400)
    .height(180)
    .x(d3.scaleBand())
    .margins({ left: 0, top: 0, right: 0, bottom: 50 })
    .xUnits(dc.units.ordinal)
    // .elasticX(true)
    .brushOn(false)
    .dimension(dimension)
    .barPadding(0.1)
    .outerPadding(0.05)
    .transitionDuration(1500)
    // .margins({ bottom: 10 })
    .group(dealCountGrp)
    .on("renderlet", function (d) {
      sizeChart.selectAll("g.x.axis .tick text").call(Wrapper, 1);
    })
      // define the bar  lables
    .renderlet((chart) => {
      var gLabels = chart.select(".labels");
      if (gLabels.empty()) {
        gLabels = chart
          .select(".chart-body")
          .append("g")
          .classed("labels", true);
      }

      var gLabelsData = gLabels.selectAll("text").data(chart.selectAll(".bar"));
      gLabelsData.exit().remove(); //Remove unused elements

      gLabelsData.enter().append("text"); //Add new elements

      gLabelsData
        .attr("text-anchor", "middle")
        .attr("fill", "white")
        .text(function (d) {
          return d3.select(d).data()[0].data.value;
        })
        .attr("x", function (d) {
          return +d.getAttribute("x") + d.getAttribute("width") / 2;
        })
        .attr("y", function (d) {
          return +d.getAttribute("y") + 15;
        })
        .attr("style", function (d) {
          if (+d.getAttribute("height") < 10) return "display:none";
        });
    });
  sizeChart.yAxis().ticks(0);
  return sizeChart;
};

export const SizeOfRecipientFirms = (props) => (
  <ChartTemplate
    chartFunction={sizeChartFunc}
    title="Use of Financing Resources"
  />
);
